import Cookies from "js-cookie";
export default  () => {
	if (sessionStorage.getItem('forthistabballotid') && sessionStorage.getItem('forthistabballotid')!="" && sessionStorage.getItem('forthistabballotid')!= Cookies.get("ballot_id"))  {
	 return true;
	} else {
	return false;
	}
}
